export const getPreviewStyles = (_, { palette = {} }) => ({
  preview: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    '& .loading-placeholder': {
      flexGrow: 1,
      borderRadius: '6px',
      background: palette.neutralLight || '#EDEBE9',
    },
    '& .spinner-box': {
      marginTop: 16,
      marginBottom: 16,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& .spinner-text': {
        marginLeft: 8,
        fontSize: 16,
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '22px',
        color: palette.neutralSecondary || '#605E5C',
      },
    },
    '& .panel-switch': {
      display: 'flex',
      '& .panel-button': {
        height: '40px',
        width: '44px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: '16px',
        '&.selected': {
          borderBottom: `2px solid ${palette.themePrimary || '#0078d4'}`,
          '& span': {
            fontWeight: 600,
          },
        },
      },
    },
    '& .scene-panel': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      maxHeight: 'calc(100% - 72px)',
      '& img': {
        width: '100%',
        borderRadius: 6,
        maxHeight: '100%',
        objectFit: 'contain',
      },
    },
    '& .video-panel': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      '& .video-placeholder': {
        width: '100%',
        color: '#ffffff',
        height: '400px',
        borderRadius: 6,
        overflow: 'hidden',
        '& div': {
          boxSizing: 'border-box',
        },
      },
      '& .video-wrapper': {
        width: '100%',
        '&.hidden': {
          display: 'none',
        },
        '& .video-container': {
          width: '100%',
          '& .video-previewer-root': {
            '& .time': {
              display: 'flex',
              marginLeft: '16px',
              marginRight: '12px',
              fontSize: '12px',
              '& span.divider': {
                marginLeft: '4px',
                marginRight: '4px',
                color: palette.neutralSecondary || 'rgba(0, 0, 0, 0.54)',
              },
              '& span.totalTime': {
                color: palette.neutralSecondary || 'rgba(0, 0, 0, 0.54)',
              },
            },
            backgroundColor: 'transparent',
            marginTop: '24px',
            '& svg': {
              fill: '#424242',
            },
            '& i[data-icon-name]': {
              height: '24px',
            },
            '& i[data-icon-name="videoUnmute"]': {
              height: '20px',
            },
            '& .ms-Slider-thumb, .ms-Slider-thumb:active, .ms-Slider-thumb:hover': {
              backgroundColor: '#238ADA',
              border: 'none',
              boxShadow: '1px 1px 1px #D2D1D1,-1px 1px 1px #D2D1D1,1px -1px 1px #D2D1D1,-1px -1px 1px #D2D1D1',
            },
            '& .ms-Slider': {
              marginRight: '8px',
            },
            '& .ms-Slider-active': {
              backgroundColor: '#238ADA',
            },
            '& .ms-Slider-inactive': {
              backgroundColor: '#DAD9D8',
            },
          },
        },
      },
      '& video': {
        width: '100%',
        borderRadius: 6,
        boxShadow: '0px 0.6px 1.8px 0px rgba(0, 0, 0, 0.10), 0px 3.2px 7.2px 0px rgba(0, 0, 0, 0.13)',
      },
    },
    '& .message-bar': {
      marginBottom: '16px',
    },
  },
});
